var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.49,
    height: 28.49,
    viewBox: "0 0 28.49 28.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146900",
    "data-name": "Group 146900",
    transform: "translate(-1.755 -1.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50141",
    "data-name": "Path 50141",
    d: "M6.1,25.9a14,14,0,1,0,0-19.8,14,14,0,0,0,0,19.8Zm1.414-1.414a12,12,0,1,1,16.968,0,12,12,0,0,1-16.968,0Z",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50142",
    "data-name": "Path 50142",
    d: "M11.414,12.98l3.273-3.273a1,1,0,1,0-1.414-1.414L8.8,12.761a1.3,1.3,0,0,0,.919,2.219H23a1,1,0,0,0,0-2Zm9.7,6.04-2.868,3.327a1,1,0,0,0,1.515,1.306l3.865-4.484a1.3,1.3,0,0,0-.984-2.149H9a1,1,0,0,0,0,2Z",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.ca065554d483de99fd162c666379bd1b.svg";
export { ForwardRef as ReactComponent };